import(/* webpackMode: "eager" */ "/app/src/components/Glossary/DefinitionList.tsx")